import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Good.Good_Minimal}
    mutation UpdateGood($id: ID!, $title: String!, $enterpriseId: ID, $placeId: ID) {
        updateGood(input: { id: $id, title: $title, enterpriseId: $enterpriseId, localId: $placeId }) {
            errors
            status
            statusCode
            good {
                ...Good_Minimal
            }
        }
    }
`
